// src/store/slices/filterSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { FilterState, SavedReportsResponse } from '../../components/types/types';

const initialState: FilterState = {
  filterId: '',
  filter: '',
  savedReports: null,
  isLoading: false,
  error: null,
};

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    saveFilterData: (
      state,
      action: PayloadAction<{ filterId: string; filter: string }>,
    ) => {
      state.filterId = action.payload.filterId;
      state.filter = action.payload.filter;
    },
    setSavedReports: (state, action: PayloadAction<SavedReportsResponse>) => {
      state.savedReports = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { saveFilterData, setSavedReports, setLoading, setError } =
  filterSlice.actions;

export default filterSlice.reducer;